import { useEffect, useState } from 'react';
import { VideoSize } from '@/util/useVideoSize.ts';

export const useResponsiveCanvas = (parentRect: DOMRect | null, videoSize: VideoSize | null) => {
  // This hook calculates the Widht & Height of the selfie-screen canvas
  // depending on the width & height of the parent DIV

  // The max video size also limits the canvas

  // Size of the Frame images provided by the app;
  const ratio = 1080 / 1350;

  // Reference the Parent Container which defines the maximim Sizes
  const [canvasHeight, setCanvasHeight] = useState<number>(480);
  const [canvasWidth, setCanvasWidth] = useState<number>(2 / ratio);
  const [videoOffset, setVideoOffset] = useState<{ left: number; top: number }>({ left: 500, top: 500 });

  const setSize = () => {
    const paddingX = 2 * 30; // 30px padding to the left+right
    const paddingY = 30 + 200; // 30px padding top + 200 padding for controls

    if (parentRect && videoSize) {
      const paddedWidth = Math.min(parentRect.width - paddingX, videoSize.width);
      const paddedHeight = Math.min(parentRect.height - paddingY, videoSize.height);
      const fillWidth = paddedWidth;
      const fillHeight = paddedWidth / ratio;

      if (fillHeight > paddedHeight) {
        setCanvasHeight(paddedHeight);
        setCanvasWidth(paddedHeight * ratio);

        const offsetLeft = (paddedHeight * ratio - videoSize.width) / 2;
        const offsetTop = (paddedHeight - videoSize.height) / 2;
        setVideoOffset({ left: offsetLeft, top: offsetTop });
      } else {
        setCanvasWidth(fillWidth);
        setCanvasHeight(fillHeight);

        const offsetLeft = (fillWidth - videoSize.width) / 2;
        const offsetTop = (fillHeight - videoSize.height) / 2;
        setVideoOffset({ left: offsetLeft, top: offsetTop });
      }
    }
  };

  useEffect(() => {
    setSize();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [parentRect, videoSize]);

  return {
    width: canvasWidth,
    height: canvasHeight,
    videoOffset,
  };
};
